import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { LocalStorageTablesShape } from "state/tables/tableHelpers";

const initialState: LocalStorageTablesShape = {};

export const tablesSlice = createSlice({
  name: "tables",
  initialState,
  reducers: {
    setTables: (state, action: PayloadAction<LocalStorageTablesShape>) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        state[key] = {
          ...state[key],
          ...value,
        };
      });
    },
    clearTableFilters: (
      state,
      action: PayloadAction<{ tableName: string }>,
    ) => {
      const { tableName } = action.payload;

      state[tableName].filters = [];
    },
    clearTablePage: (state, action: PayloadAction<{ tableName: string }>) => {
      const { tableName } = action.payload;

      if (state[tableName]?.listing) {
        state[tableName].listing.page = 1;
      }
    },

    clearTableListings: () => {
      return initialState;
    },
  },
});

export const {
  setTables,
  clearTableFilters,
  clearTableListings,
  clearTablePage,
} = tablesSlice.actions;

export const selectTables = (state: RootState) => state.tables;
export const selectTableListings = createSelector(
  (state: RootState) => state.tables,
  (state: RootState, tableName: string) => {
    return tableName;
  },

  (tables, tableName) => {
    return tables[tableName]?.listing;
  },
);

export default tablesSlice.reducer;
